import './App.less';
import { Provider as InversifyProvider } from 'inversify-react';
import { Provider, useDispatch, useSelector } from 'react-redux'
import { store } from './redux/store';
import RoutingContainer from "./pages/routing/routingContainer";
import React, { useEffect } from "react";
import { BrowserRouter, useNavigate } from "react-router-dom";
import ApiService from "./services/apiService";
import { CrudLayout } from 'digimuth-components/dist';
import { Container } from 'inversify';
import { AuthProvider, AuthProviderProps, initUserManager, useAuth, UserManager } from 'oidc-react';
import SiderMenu from './components/siderMenu/siderMenu';
import HeaderContainer from './components/header/headerContainer';
import { ConfigProvider, Spin } from 'antd';
import plPL from 'antd/lib/locale/pl_PL';
import { HubConnectionBuilder } from "@microsoft/signalr";
import { NotificationDto } from './api';
import { setLatestNotification } from './redux/notificationSlice';
import { getIsChangingOrganisation } from './redux/alertSlice';
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isoWeek from "dayjs/plugin/isoWeek";
import objectSupport from "dayjs/plugin/objectSupport";
import { gweTheme } from './theme';
import 'dayjs/locale/pl';
import relativeTime from 'dayjs/plugin/relativeTime';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isBetween);
dayjs.extend(isoWeek);
dayjs.extend(objectSupport);
dayjs.extend(relativeTime);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.locale('pl');

const authSettings: AuthProviderProps = {
    authority: process.env.REACT_APP_URL,
    clientId: "Digimuth.GwExperts.Web",
    redirectUri: process.env.REACT_APP_URL,
    autoSignIn: false,
    automaticSilentRenew: true,
    scope: "openid Digimuth.GwExperts.WebAPI profile offline_access"
};

export const userManager: UserManager | undefined = initUserManager(authSettings);

function App() {
    const container = new Container();
    container.bind(ApiService).toSelf().inSingletonScope();

    return (
        <ConfigProvider locale={plPL} theme={gweTheme}>
            <Provider store={store}>
                <InversifyProvider container={container}>
                    <BrowserRouter>
                        <AppInternal />
                    </BrowserRouter>
                </InversifyProvider>
            </Provider>
        </ConfigProvider>
    )
}

function AppInternal() {

    const navigate = useNavigate();

    return <>
        {/* @ts-ignore */}
        <AuthProvider
            userManager={userManager}
            onSignIn={u => {
                const fromState = (u?.state as any)?.targetPath;
                const targetUrl = fromState ? fromState : "/";
                navigate(targetUrl, { replace: true });
            }}
            autoSignIn={false}>
            <Layout />
        </AuthProvider>
    </>
}

const sendNotificationMethodName = "sendNotification";

function Layout() {
    const auth = useAuth();
    const dispatch = useDispatch();
    const isChangingOrganisation = useSelector(getIsChangingOrganisation);

    useEffect(() => {
        if (!auth.userData) {
            return;
        }

        const hubConnection = new HubConnectionBuilder()
            .withUrl("/hubs/notifications", { accessTokenFactory: () => auth.userData!.access_token })
            .withAutomaticReconnect()
            .build();

        hubConnection.on(sendNotificationMethodName, (data: NotificationDto) => {
            dispatch(setLatestNotification(data));
        });

        hubConnection.start();

        return () => {
            hubConnection.off(sendNotificationMethodName);
            hubConnection.stop();
        }
    }, [auth, dispatch]);

    return <Spin spinning={isChangingOrganisation}>
        <CrudLayout
            breadcrumb={<></>}
            siderMenu={<SiderMenu />}
            header={<HeaderContainer />}
            footerContent={<></>}
            showSider={false}
        >
            <RoutingContainer />
        </CrudLayout>
    </Spin>
}

export default App;
